export default "__VITE_ASSET__KoXa7hLP__"